import {
  GetUploadByKeyPathParamsPlatformEnumKey,
  UploadDto,
} from '@app/modules/social-export/social-export.types';
import {
  useSocialExportGetUploadById,
  useSocialExportGetUploadByPlatformAndKey,
} from '@mi-front/api-v2';
import { UseQueryResult } from '@tanstack/react-query';

type UseSocialUploadParams = { id: string } | { id: { platform: string; key: string } };

type UseSocialUploadOptions = {
  enabled?: boolean;
};

export function useSocialUpload(
  params: UseSocialUploadParams,
  options: UseSocialUploadOptions = {},
): UseQueryResult<UploadDto> {
  const { enabled = true } = options;

  if (typeof params.id === 'string') {
    return useSocialExportGetUploadById(params.id, {
      query: {
        enabled: enabled && !!params.id,
        refetchInterval: (query: { state?: { data?: { isPending?: boolean } } }) => {
          return query?.state?.data?.isPending ? 5000 : false;
        },
      },
    }) as UseQueryResult<UploadDto>;
  }

  if (typeof params.id === 'object' && params.id.platform && params.id.key) {
    return useSocialExportGetUploadByPlatformAndKey(
      params.id.key,
      params.id.platform as GetUploadByKeyPathParamsPlatformEnumKey,
      {
        query: {
          enabled: enabled && !!params.id.key && !!params.id.platform,
          refetchInterval: (query: { state?: { data?: { isPending?: boolean } } }) => {
            return query?.state?.data?.isPending ? 5000 : false;
          },
        },
      },
    ) as UseQueryResult<UploadDto>;
  }

  // This should never happen due to TypeScript, but handle it gracefully
  throw new Error('id must be either a string or an object with platform and key');
}
